import { SELLER_COUNTRIES } from '../constants';

export const isFromSellerCountry = (country: string): boolean => SELLER_COUNTRIES.includes(country);
